import { useEffect } from "react";

export default function PhoneTracking({phoneNumber="(562) 485-5485"}) {
    useEffect(() => {
        if (window.gtag) {
            window.gtag('config', 'AW-17005273287/v-jyCMPg2IEcEMfB36w_', {
                phone_conversion_number: '(562) 485-5485'
            });
        }
    }, []);

    return (
        <a className="btn-link" href="tel:+15624855485">{phoneNumber}</a>
    );
}
